<div class="text">
  <div class="text__label">
    <ion-checkbox (ionChange)="save($event)" [(ngModel)]="question.editingValue" [name]="question.key"
      #formControl="ngModel" required #checkbox>
    </ion-checkbox>

    <ion-label (click)="checkbox.checked = !checkbox.checked">
      {{question.label}}
    </ion-label>
  </div>
</div>
